module.exports = __webpack_public_path__ + "static/img/nuestro-proposito.b5aed70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nuestro-proposito.png
// module id = 5fsb
// module chunks = 0